<header class="flex header">
  <h2>
    {{ 'relatedInfoModal.title' | translateWF: 'Knittings' }}
  </h2>
  <p-button icon="pi pi-times" (click)="onClose()" />
</header>
<section class="content">
  <h5 class="mb-5">
    {{ 'relatedInfoModal.KnittingOrders' | translateWF: 'Knitting Orders Related' }}
  </h5>
  <p-timeline [value]="knittings">
    <ng-template let-knitting pTemplate="content" class="w-full">
      {{ knitting.knittingOrderNumber }}
    </ng-template>
  </p-timeline>
</section>
<footer>
  <p-button class="w-full" [label]="'Exit' | translateWF: 'Exit'" variant="outlined" (click)="onClose()" />
</footer>
